import React, { useEffect, useRef, useState } from "react";
import {
  FaCrown,
  FaEllipsisVertical,
  FaFilePen,
  FaGift,
  FaHeart,
  FaComment,
  FaTrash,
  FaChevronDown,
  FaChevronUp,
  FaArrowUp,
  FaArrowDown,
  FaBolt,
  FaSignal,
  FaUsers,
} from "react-icons/fa6";
import { FaEdit, FaStar } from "react-icons/fa";
import SignalsService from "../../../services/Signals";
import { useNavigate } from "react-router-dom";

/**
 * props:
 *  - pkg: { id, title, status, description, signals: { free: [], premium: [] }, revenue, successRate, price, counts... }
 *  - onRequestDelete(packageId)
 */
export default function PackageItem({
  pkg,
  onRequestDelete,
  onViewAllSignals,
}) {
  const [openDetails, setOpenDetails] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [signalTab, setSignalTab] = useState(false);
  const menuRef = useRef(null);
  const [signals, setSignals] = useState([]);
const navigate = useNavigate();
  // console.log(pkg)

  useEffect(() => {
    function handleDocClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("click", handleDocClick);
    return () => document.removeEventListener("click", handleDocClick);
  }, []);

 
useEffect(() => {
  if (!openDetails || !pkg._id) return;

  const getSignals = async () => {
    try {
      const res = await SignalsService.getAll({
        package: pkg._id,
      });

      const data = res?.data?.data;
      setSignals(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to fetch signals", err);
    }
  };

  getSignals();
}, [openDetails, pkg._id]);


  function toggleDetails() {
    setOpenDetails((s) => !s);
  }

  function openMenu(e) {
    e.stopPropagation();
    setMenuOpen((v) => !v);
  }

  function handleSetDraft() {
    console.log("Set draft", pkg._id);
    setMenuOpen(false);
  }

  function handleEdit() {
    console.log("Edit package", pkg._id);
    setMenuOpen(false);
  }

  function handleConfirmDelete() {
    setMenuOpen(false);
    onRequestDelete(pkg._id);
  }

  return (
    <div
      id={`package-${pkg._id}`}
      className="bg-white rounded-xl p-4 shadow-sm border border-gray-100"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-1">
            <h3 className="font-bold text-gray-900">{pkg.name}</h3>

            <span
              className={`text-xs px-2 py-1 rounded-full ${
                pkg.status === "active"
                  ? "bg-green-100 text-green-700"
                  : pkg.status === "pending"
                    ? "bg-yellow-100 text-yellow-700"
                    : "bg-blue-100 text-blue-700"
              }`}
            >
              {pkg.status}
            </span>
          </div>

          <p className="text-sm text-gray-600 mb-2">{pkg.description}</p>

          <div className="flex items-center space-x-4 text-xs text-gray-500 mb-2">
            <span className="flex gap-1">
              <FaSignal />
              {pkg.type}
            </span>

            <span className="flex gap-1">
              <FaStar />
              {pkg.likeCount} Likes
            </span>

            <span className="flex gap-1">
              <FaUsers />
              {pkg.user?.fullName}
            </span>
          </div>

          <div className="flex items-center space-x-3 text-xs">
            <span className="bg-blue-50 flex items-center text-blue-700 px-2 py-1 rounded-full">
              <FaGift className="mr-1" />
              {pkg.packageBadge}
            </span>

            <span className="bg-amber-50 flex items-center text-amber-700 px-2 py-1 rounded-full">
              <FaCrown className="mr-1" />
              {pkg.duration?.days} Days
            </span>

            <span className="font-semibold text-green-600">
              {pkg.price?.toLocaleString("en-US")}
            </span>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <button
            onClick={toggleDetails}
            className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors"
          >
            {openDetails ? (
              <FaChevronUp className="text-gray-600" />
            ) : (
              <FaChevronDown className="text-gray-600" />
            )}
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-3 mb-3">
        <div className="bg-gray-50 rounded-lg p-3">
          <p className="text-xs text-gray-500 mb-1">Package Price</p>
          <p className="font-bold text-success">
            {pkg.price?.toLocaleString("en-US")}
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-3">
          <p className="text-xs text-gray-500 mb-1">Duration</p>
          <p className="font-bold text-primary">{pkg.duration?.days} Days</p>
        </div>
      </div>

      {/* Package Details */}
      <div
        className={`package-details border-t border-gray-100 pt-4 mt-4 ${openDetails ? "" : "hidden"}`}
      >
        <div className="flex items-center justify-between mb-3">
          <h4 className="font-semibold text-gray-900">Recent Signals</h4>
          <button
            onClick={() => navigate("/createSignal")}
            className="text-sm text-primary font-medium"
          >
            Add Signal
          </button>
        </div>

        {/* Signal Tabs */}
        <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-4">
          <button
            onClick={() => setSignalTab(false)}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium ${signalTab === false ? "bg-white text-gray-900 shadow-sm" : "text-gray-600 hover:text-gray-900"}`}
          >
            Free Signals
          </button>
          <button
            onClick={() => setSignalTab(true)}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium ${signalTab === true ? "bg-white text-gray-900 shadow-sm" : "text-gray-600 hover:text-gray-900"}`}
          >
            Premium Signals
          </button>
        </div>

        {/* Signals List */}
        {/* {isPremium = signals?.isPremium.map((type) => ( */}
        {/* <div key={type = signals?.isPremium ? "premium" : "free" } className={`signals-content space-y-3 ${signalTab !== type ? "hidden" : ""}`}> */}
        {signals.map((s, idx) => (
          <div
            key={`${s?.isPremium}-${idx}`}
            className={`flex items-center justify-between p-3 bg-gray-50 rounded-lg ${signalTab !== s?.isPremium ? "hidden" : ""}`}
          >
            <div className="flex items-center space-x-3">
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center`}
              >
                {/* {s.icon && React.createElement(s.icon, { className: s.iconColor })} */}
                <img
                  src={`${"https://api.7-trade.ir/"}${s?.image?.path}`}
                  alt={s.title}
                />
              </div>
              <div>
                <p className="font-medium text-gray-900">{s.description}</p>
                <p className="text-xs text-gray-500">
                  {s.createdAt} •{" "}
                  {s?.type === "sell"
                    ? "SELL"
                    : s?.type === "buy"
                      ? "BUY"
                      : "HOLD"}
                </p>
              </div>
            </div>

            <div className="text-right">
              <p
                className={`font-semibold ${s?.delta === "Pending" ? "text-green-500" : "text-gray-500"}`}
              >
                {s?.delta ? s?.delta : "Pending"}
              </p>
              <div className="flex items-center space-x-2 text-xs text-gray-500">
                <span className="flex gap-1 items-center">
                  <FaHeart /> {s.likesCount}
                </span>
                <span className="flex gap-1 items-center">
                  <FaComment /> {s.commentsCount}
                </span>
              </div>
            </div>
          </div>
        ))}
        {/* </div> */}
        {/* ))} */}

        <button
          onClick={() => onViewAllSignals(signals)}
          className="w-full mt-3 py-2 text-sm text-primary font-medium border border-primary/20 rounded-lg hover:bg-primary/5 transition-colors"
        >
          View All Signals ({signals.length})
        </button>
      </div>
    </div>
  );
}
